/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTagRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'
import {GetTagResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/tag.pb'


export const getTag = (request: GetTagRequest, options?: CashRequestOptions) => post<GetTagRequest, GetTagResponse>("/2.0/cash/get-tag", request, {...options, rejectOnError: true })